module.exports = "/assets/data/2b81638c4077a2cc5b85fa051f895755-LS3.data.json";